(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const initializeCatalogProductScroll = () => {
    const grids = document.querySelectorAll('body.template-collection .product-grid');

    grids.forEach((grid) => {
      if (grid.dataset.catalogProductScroll === 'true') return;

      grid.dataset.catalogProductScroll = 'true';

      let wheelLock = false;

      grid.addEventListener(
        'wheel',
        (event) => {
          if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
          if (grid.scrollWidth <= grid.clientWidth + 1) return;

          const cards = Array.from(grid.querySelectorAll('.product-grid__item'));
          if (cards.length < 2) return;

          const maxScroll = grid.scrollWidth - grid.clientWidth;
          const goingNext = event.deltaY > 0;
          const atStart = grid.scrollLeft <= 1 && !goingNext;
          const atEnd = grid.scrollLeft >= maxScroll - 1 && goingNext;

          if (atStart || atEnd) return;

          event.preventDefault();
          if (wheelLock) return;

          const currentIndex = cards.reduce((closestIndex, card, index) => {
            const closestDistance = Math.abs(cards[closestIndex].offsetLeft - grid.scrollLeft);
            const cardDistance = Math.abs(card.offsetLeft - grid.scrollLeft);

            return cardDistance < closestDistance ? index : closestIndex;
          }, 0);
          const targetIndex = Math.max(0, Math.min(cards.length - 1, currentIndex + (goingNext ? 1 : -1)));

          wheelLock = true;
          grid.scrollTo({
            left: Math.min(cards[targetIndex].offsetLeft, maxScroll),
            behavior: 'smooth',
          });

          window.setTimeout(() => {
            wheelLock = false;
          }, 360);
        },
        { passive: false }
      );
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCatalogProductScroll, { once: true });
  } else {
    initializeCatalogProductScroll();
  }

  document.addEventListener('shopify:section:load', initializeCatalogProductScroll);

  } catch(e) { console.error(e); }
})();
})();
